// extracted by mini-css-extract-plugin
export default {"cautionBox":"c9-z"};